import PropTypes from 'prop-types';
import { m } from 'framer-motion';
// @mui
import { alpha, useTheme, styled } from '@mui/material/styles';
import { Box, Grid, Button, Container, Typography, LinearProgress, ToggleButtonGroup, ToggleButton, ButtonGroup, TextField, InputAdornment, Checkbox, Link, IconButton, Stack, FormControlLabel } from '@mui/material';
// hooks
import { Link as RouterLink, useNavigate } from 'react-router-dom';

import useResponsive from 'src/hooks/useResponsive';
// utils
import { fPercent } from 'src/utils/formatNumber';
// _mock_
import { _skills } from 'src/_mock';
// components
import Image from 'src/components/Image';
import Iconify from 'src/components/Iconify';
import { MotionViewport, varFade } from 'src/components/animate';
import img1 from 'src/assets/images/home-dark-hero-image.png'
import img2 from 'src/assets/images/what-2.jpg'
import InstituteLogin from './InstitudeLogin';
import { useEffect, useState } from 'react';
import useAuth from 'src/hooks/useAuth';
import StudentView from './StudentView';
import { API_ENDPOINTS } from 'src/api/apiEndPoints';
import { LoadingButton } from '@mui/lab';
import axios from 'axios';
import { ResetPasswordForm } from 'src/sections/auth/reset-password';
import { useSnackbar } from 'notistack';
// ----------------------------------------------------------------------
// import { useAuth0, withAuth0 } from "@auth0/auth0-react";

const RootStyle = styled('div')(({ theme }) => ({
    textAlign: 'center',
    // paddingTop: theme.spacing(20),
    paddingBottom: theme.spacing(0),
    [theme.breakpoints.up('md')]: {
        textAlign: 'left',
        paddingTop: theme.spacing(20),
    },
    [theme.breakpoints.only('xs')]: {
        paddingTop: theme.spacing(5),
    // paddingBottom: theme.spacing(5),

    },
   
}));

const CssTextField = styled(TextField)({
    '& label.Mui-focused': {
      color: 'white',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#e61471',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'white',
      },
      '&:hover fieldset': {
        borderColor: 'white',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'white',
      },
    },
  });
  

// ----------------------------------------------------------------------

export default function Typeoflogin({ gotoinstitudelogin }) {
    const theme = useTheme();

    const isDesktop = useResponsive('up', 'md');
    const { user , login, logout, getAccessTokenSilently,authintication ,getStudentProfile,
        getUser} = useAuth();
    const [id, setId] = useState('');
    const [view, setView] = useState('both');

    useEffect(() => {
        const initializeAuth = async () => {
            await authintication();  // Ensure authintication doesn't cause side effects on each render
        };

        initializeAuth();
    }, [authintication]);
    
    

    const isLight = theme.palette.mode === 'light';

    const shadow = `-40px 40px 80px ${alpha(isLight ? theme.palette.grey[500] : theme.palette.common.black, 0.48)}`;

    return (
        <RootStyle >
            <Container component={MotionViewport} >
            <Grid container direction={{ xs: 'row-reverse', md: 'row-reverse' }} spacing={8} sx={{mt:'5vh'}}>
                    {/* {isDesktop && (
                       
                    )} */}

                    <Grid item xs={12} md={6} sx={{mb:3}} lg={5}>
                        {view == 'both' && <Bothview gotoinstitudelogin={() => setView('institude')} />}
                        {view == 'institude' && <InstituteLogin gotoback={() => setView('both')} />}


                    
                    </Grid>
                    <Grid item xs={12} md={6} lg={7} sx={{ mt: {xs: 0, md: 0}, p: 0 }} >
                            {/* <Grid container spacing={3}> */}
                            {/* <Grid item xs={12}> */}
                            {/* <m.div variants={varFade().inDown}>
                                <Image
                                    alt="our office 1"
                                    src={img1}
                                    // ratio=""
                                    sx={{
                                        borderRadius: 1,
                                        // boxShadow: shadow,
                                    }}
                                />
                            </m.div> */}
                            <img src={img1}/>
                          
                        </Grid>
                </Grid>
            </Container>
        </RootStyle>
    );
}

// ----------------------------------------------------------------------


function Bothview({ gotoinstitudelogin }) {
    const { user:userdata, login, logout, getAccessTokenSilently, loginWithRedirect } = useAuth();
    const [showPassword, setShowPassword] = useState(false);
   
    // console.log(user,)
    const [alignment, setAlignment] = useState('institute');
    const [value, setValue] = useState({ email: '', password: "" })
    const [error, setError] = useState({})
    const [isSubmitting, setisSubmitting] = useState(false)
    const { enqueueSnackbar } = useSnackbar();
    const [user, setUser] = useState({});
    const navigate = useNavigate();
    useEffect(() => {
      console.log(userdata);
      let token = localStorage.getItem("accessToken");
      if (token) {
        setUser(userdata);
        navigate("/institutes");
      }
    }, [userdata]);
    const handleChange = (event, newAlignment) => {
        if (!newAlignment) {
            return
        }
        // if (newAlignment == 'student') {
        //     gotologin()
        // }
        setAlignment(newAlignment);
    };

    const gotologin = () => {
        login()

    }
    const ins_login = async () => {
        setisSubmitting(true)
        try {

            const res = await axios.post(API_ENDPOINTS.INS_LOGIN, value)
            console.log(res)
            window.location.href = res.data.domain + "?accessToken=" + res.data.access

        } catch (error) {
            if (error?.response?.data?.non_field_errors) {

                enqueueSnackbar(error?.response?.data?.non_field_errors, { variant: 'error' })
            }
            console.log(error.response)
            setError(error.response.data)
        }
        setisSubmitting(false)


    }

    return (
        <>
            {alignment != 'forget' && <ToggleButtonGroup
                fullWidth
                color="info"
                value={alignment}
                exclusive
                onChange={handleChange}
                sx={{ mb: 2, bgcolor:'#0E2135'  }}
            >
                <ToggleButton  sx={{ color:'#ffffff'  }}   fullWidth value="institute">Institute Login</ToggleButton>
                <ToggleButton  sx={{ color:'#ffffff'  }} fullWidth value="student">Student Login</ToggleButton>
            </ToggleButtonGroup>
            }
            {alignment == 'institute' && <>
                <Stack spacing={3} sx={{ my: 2, mt: 2,}}  >

                    <CssTextField
                        value={value.email}
                        onChange={e => setValue({ ...value, email: e.target.value })}
                        error={error.email}
                        color="secondary"
                       
                        sx={{ input: { color: 'white' },}} 
                        // sx={{bgcolor:'transparent', }}
                        helperText={error.email}
                        name="email"
                        label="Email address" />

                    <CssTextField

                        value={value.password}
                        onChange={e => setValue({ ...value, password: e.target.value })}
                        error={error.password}
                        helperText={error.password}
                        color="secondary"
                        name="password"
                        label="Password"
                        sx={{ input: { color: 'white' },}} 
                        type={showPassword ? 'text' : 'password'}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                        <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </Stack>
                <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
                    {/* <FormControlLabel
                        label="Remember me"
                        control={
                            <Checkbox
                                checked
                            />
                        }
                    /> */}
                    <Link  sx={{ color: '#E61471'}} variant="subtitle2" onClick={() => setAlignment('forget')}>
                        Forgot your password?
                    </Link>
                </Stack>
             
                <Box sx={{ '& button': { m: 1 } }}>
                    <LoadingButton sx={{ bgcolor: '#E61471!important', shadow:'0'}} onClick={() => ins_login()} size="large" fullWidth type="submit" variant="contained"  loading={isSubmitting}>
                    Login
                </LoadingButton>
                <Button sx={{ paddinBottom: 20, }} color="secondary"  size="large" onClick={()=> window.open("https://www.eduley.com/")} type="submit" fullWidth variant="outlined" loading={isSubmitting}>
                    Back to Home
                </Button>
             </Box>
                       
              

            </>}


            {alignment == 'forget' && <>
                <Stack sx={{ mt: 2 }}>

                    <ResetPasswordForm />
                    <Button sx={{ mt: 2, color: '#ffffff' }} size="large" onClick={() => setAlignment('institute')}>Back</Button>
                </Stack>
            </>}
            {alignment == 'student' && <StudentView gotoback={() => setAlignment('institute')} user={user}/>}
            {/* <Button
                fullWidth
                variant="outlined"
                color="primary"
                size="large"
                onClick={() => gotoinstitudelogin()}
                endIcon={<Iconify icon={'ic:round-arrow-right-alt'} width={24} height={24} />}
            >
                Institute Login
            </Button>
            {/* </m.div>
            <m.div variants={varFade().inRight}> 
            {!user.id ? <Button
                sx={{ mt: 5 }}
                fullWidth
                onClick={() => gotologin()}
                variant="contained"
                color="info"
                size="large"
                endIcon={<Iconify icon={'ic:round-arrow-right-alt'} width={24} height={24} />}
            >
                Student Login
            </Button> :
                <Button
                    sx={{ mt: 5 }}
                    fullWidth
                    onClick={() => logout()}
                    variant="contained"
                    color="info"
                    size="large"
                    endIcon={<Iconify icon={'ic:round-arrow-right-alt'} width={24} height={24} />}
                >
                    Logout
                </Button>} */}
        </>
    );
}
